import React from "react";

// Single source of truth for the Leoprinting product wordmark. It's a wide
// horizontal logo (~5.5:1), so size it by HEIGHT and keep width auto to
// preserve the aspect ratio. Callers set the height via `className`
// (default h-12). Used across the PMS app (auth screens, sidebar) so the
// brand stays consistent — change the source here and it updates everywhere.
const LOGO_SRC = process.env.REACT_APP_PUBLIC_URL_LOGO;

const AppLogo = ({ className = "h-10 w-auto", alt = "Leoprinting" }) => (
  <img
    src={LOGO_SRC}
    alt={alt}
    className={`${className} object-contain`}
  />
);

export default AppLogo;
